import React from "react";
import PropTypes from 'prop-types';
import {connect} from "react-redux";

class ColumnHeader extends React.Component {

	constructor(props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
		this.handleMinimizeClick = this.handleMinimizeClick.bind(this);
		this.handleMaximizeClick = this.handleMaximizeClick.bind(this);
	}

	handleClick(e) {
		e.preventDefault();

		if (this.props.onClick) {
			this.props.onClick(this.props.id);
		}
	}

	handleMinimizeClick(e) {
		e.preventDefault();
		e.stopPropagation();

		if (this.props.onMinimize) {
			this.props.onMinimize(this.props.id);
		}
	}

	handleMaximizeClick(e) {
		e.preventDefault();
		e.stopPropagation();

		if (this.props.onMaximize) {
			this.props.onMaximize(this.props.id);
		}
	}

	render() {
		return(
			<div className="wcHeader" style={ { backgroundColor: this.props.configuration.defaultBackgroundColor } } onClick={ this.handleClick }>
				<div className="wcContent">
					<span>{ this.props.text } { this.props.unread ? <span className="wcUnread">*</span> : '' }</span>
					{ this.props.unreadNumber > 0 && <span className="wcRedCounter">{ this.props.unreadNumber }</span> }
					{ this.props.contentElements }
				</div>
				<div className="wcButtons">
					{ this.props.children }
					{ this.props.minimizable &&
						<React.Fragment>
							{ this.props.minimized ? (
								<a href="#" className="wcFunctional wcMaximize" onClick={ this.handleMaximizeClick } title={ this.props.i18n.maximize } />
							) : (
								<a href="#" className="wcFunctional wcMinimize" onClick={ this.handleMinimizeClick } title={ this.props.i18n.minimize } />
							)}
						</React.Fragment>
					}
					{ this.props.closable && this.props.closeButton }
				</div>
			</div>
		)
	}

}

ColumnHeader.defaultProps = {
	contentElements: [],
	closable: false,
	minimizable: true
}

ColumnHeader.propTypes = {
	configuration: PropTypes.object.isRequired,
	closable: PropTypes.bool.isRequired,
	minimizable: PropTypes.bool.isRequired,
	minimized: PropTypes.bool.isRequired,
	onClick: PropTypes.func,
	onMinimize: PropTypes.func,
	onMaximize: PropTypes.func,
	closeButton: PropTypes.object,
	id: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	unreadNumber: PropTypes.number,
	contentElements: PropTypes.array.isRequired
};

export default connect(
	(state) => ({
		configuration: state.configuration,
		i18n: state.application.i18n
	})
)(ColumnHeader);